import {
  AchievementAggregation,
  AchievementCompleteRulePeriod,
  AchievementRuleTypes,
  AchievementTemplate,
  AchievementTriggers,
} from "types/achievements";

const { DIRECT, REFERRAL } = AchievementRuleTypes;
const { EXPRESSION, QUANTITY } = AchievementAggregation;
const { TRANSACTION, CUSTOM_EVENT } = AchievementTriggers;
const { OVERALL, LAST_DAY, DAY, WEEK } = AchievementCompleteRulePeriod;

export const getAchievementTemplatesData = (defaultLang: string) => {
  const data: AchievementTemplate[] = [
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "buyProductFromBrandX",
          description: "buyProductFromBrandXDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: TRANSACTION,
          type: DIRECT,
          translations: { [defaultLang]: { name: "productFromCategoryX" } },
          achievementRuleId: "f97c20a9-1980-4402-aca1-48d38bbdde4e",
          completeRule: {
            periodGoal: 1,
            period: { type: OVERALL },
          },
          aggregation: { type: QUANTITY },
          conditions: [
            {
              operator: "is_greater_or_equal",
              attribute: "transaction.category('').qty",
              data: 1,
            },
          ],
          limit: {},
        },
      ],
      name: "buyProductFromBrandX",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "buyProductWithSpecificSKU",
          description: "buyProductWithSpecificSKUDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: TRANSACTION,
          type: DIRECT,
          translations: {
            [defaultLang]: { name: "productWithSpecificSKU" },
          },
          achievementRuleId: "b76c0858-970b-4bab-a668-014da5fc8f58",
          completeRule: {
            periodGoal: 1,
            period: { type: OVERALL },
          },
          aggregation: {
            type: EXPRESSION,
            rule: "<#>transaction.sku('').qty</#>",
          },
          conditions: [],
          limit: {},
        },
      ],
      name: "buyProductWithSpecificSKU",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "make3PurchasesInLast14Days",
          description: "make3PurchasesInLast14DaysDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: TRANSACTION,
          type: DIRECT,
          translations: {
            [defaultLang]: { name: "3purchasesInLast14Days" },
          },
          achievementRuleId: "afd1ba04-9a9d-4041-9b87-156b5a6c7be1",
          completeRule: {
            periodGoal: 3,
            period: { type: LAST_DAY, value: 14 },
          },
          aggregation: { type: QUANTITY },
          conditions: [],
          limit: {
            interval: { type: "calendarDays", value: 1 },
            value: 1,
          },
        },
      ],
      name: "make3PurchasesInLast14Days",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "spend100CurrencyUnits",
          description: "spend100CurrencyUnitsDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: TRANSACTION,
          type: DIRECT,
          achievementRuleId: "ea34a89a-3acd-4004-aede-2029b446cf90",
          completeRule: {
            periodGoal: 100,
            period: { type: OVERALL },
          },
          aggregation: {
            type: EXPRESSION,
            rule: "<#>transaction.grossValue</#>",
          },
          conditions: [],
          limit: {},
          translations: {
            [defaultLang]: { name: "" },
          },
        },
      ],
      name: "spend100CurrencyUnits",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "spend1000CurrencyUnitsIn2Months",
          description: "spend1000CurrencyUnitsIn2MonthsDescription",
        },
      },
      limit: { value: 1 },
      activity: {
        data: ["january", "february"],
        operator: "is_month_of_year",
      },
      rules: [
        {
          trigger: TRANSACTION,
          type: DIRECT,
          translations: {
            [defaultLang]: { name: "spend1000CurrencyUnits" },
          },
          achievementRuleId: "2f653a29-46e5-40d7-914d-ba0af49900cc",
          completeRule: {
            periodGoal: 1000,
            period: { type: OVERALL },
          },
          aggregation: {
            type: EXPRESSION,
            rule: "<#>transaction.grossValue</#>",
          },
          conditions: [
            {
              operator: "is_month_of_year",
              attribute: "transaction.purchasedAt",
              data: ["january", "february"],
            },
          ],
          limit: {},
        },
      ],
      name: "spend1000CurrencyUnitsIn2Months",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "make4TransactionsInRow",
          description: "make4TransactionsInRowDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: TRANSACTION,
          type: DIRECT,
          translations: { [defaultLang]: { name: "4TransactionsInRow" } },
          achievementRuleId: "35191885-0165-4c3c-897a-3bee5fbb2de9",
          completeRule: {
            periodGoal: 1,
            period: { type: DAY, consecutive: 4 },
          },
          aggregation: { type: QUANTITY },
          conditions: [],
          limit: {},
        },
      ],
      name: "make4TransactionsInRow",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "completeCustomEventBuy3Products",
          description: "completeCustomEventBuy3ProductsDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: CUSTOM_EVENT,
          type: DIRECT,
          translations: { [defaultLang]: { name: "completeCustomEvent" } },
          achievementRuleId: "3b9645b7-ca5a-4b1c-9c0c-469c0415924e",
          completeRule: {
            periodGoal: 1,
            period: { type: OVERALL },
          },
          aggregation: { type: QUANTITY },
          conditions: [],
          event: "",
          limit: { value: 1 },
        },
        {
          trigger: TRANSACTION,
          type: DIRECT,
          translations: { [defaultLang]: { name: "buy3Products" } },
          achievementRuleId: "9186fa8a-8f39-4ce2-a00c-66e02ea9a79f",
          completeRule: {
            periodGoal: 3,
            period: { type: OVERALL },
          },
          aggregation: {
            type: EXPRESSION,
            rule: "<#>transaction.category('').qty</#>",
          },
          conditions: [],
          limit: {},
        },
      ],
      name: "completeCustomEventBuy3Products",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "complete5SeasonalTransactions",
          description: "complete5SeasonalTransactionsDescription",
        },
      },
      limit: { value: 1 },
      activity: {
        data: {
          from: "2024-05-01T00:00:00+02:00",
          to: "2024-08-31T00:00:00+02:00",
        },
        operator: "is_between",
      },
      rules: [
        {
          trigger: TRANSACTION,
          type: DIRECT,
          translations: { [defaultLang]: { name: "5SeasonalTransactions" } },
          achievementRuleId: "1a918823-3d1e-44c6-ae1b-22b842c50830",
          completeRule: {
            periodGoal: 5,
            period: { type: OVERALL },
          },
          aggregation: { type: QUANTITY },
          conditions: [],
          limit: {},
        },
      ],
      name: "complete5SeasonalTransactions",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "spend50CurrencyUnitsEachWeekOfMarch",
          description: "spend50CurrencyUnitsEachWeekOfMarchDescription",
        },
      },
      limit: { value: 1 },
      activity: { data: ["march"], operator: "is_month_of_year" },
      rules: [
        {
          trigger: TRANSACTION,
          type: DIRECT,
          translations: {
            [defaultLang]: { name: "50CurrencyUnitsEachWeek" },
          },
          achievementRuleId: "2a3c236a-0e5a-477b-946f-0bdb862d6932",
          completeRule: {
            periodGoal: 50,
            period: { type: WEEK, consecutive: 4 },
          },
          aggregation: {
            type: EXPRESSION,
            rule: "<#>transaction.grossValue</#>",
          },
          conditions: [
            {
              operator: "is_month_of_year",
              attribute: "transaction.purchasedAt",
              data: ["march"],
            },
          ],
          limit: {},
        },
      ],
      name: "spend50CurrencyUnitsEachWeekOfMarch",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "walk10000StepsADay",
          description: "walk10000StepsADayDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: CUSTOM_EVENT,
          type: DIRECT,
          translations: { [defaultLang]: { name: "walk10000StepsADay" } },
          achievementRuleId: "f3c434c7-6311-47e8-b24c-cb9bbeca95a6",
          completeRule: {
            periodGoal: 10000,
            period: { type: OVERALL },
          },
          aggregation: {
            type: EXPRESSION,
            rule: "",
          },
          conditions: [],
          event: "",
          limit: {
            interval: { type: "calendarDays", value: 1 },
            value: 10000,
          },
        },
      ],
      name: "walk10000StepsADay",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "maintainA7DayLoginStreak",
          description: "maintainA7DayLoginStreakDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: CUSTOM_EVENT,
          type: DIRECT,
          translations: { [defaultLang]: { name: "7DayLoginStreak" } },
          achievementRuleId: "e41ef9b5-9b57-4db5-93ad-8ce7c05c9d91",
          completeRule: {
            periodGoal: 1,
            period: { type: LAST_DAY, value: 7 },
          },
          aggregation: { type: QUANTITY },
          conditions: [],
          event: "",
          limit: {
            interval: { type: "calendarDays", value: 1 },
            value: 1,
          },
        },
      ],
      name: "maintainA7DayLoginStreak",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "add2ProductReviewsInLast60Days",
          description: "add2ProductReviewsInLast60DaysDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: CUSTOM_EVENT,
          type: DIRECT,
          translations: { [defaultLang]: { name: "add2ProductReviews" } },
          achievementRuleId: "b93ca435-461f-405c-b28f-d0befad21a1b",
          completeRule: {
            periodGoal: 2,
            period: { type: LAST_DAY, value: 60 },
          },
          aggregation: { type: QUANTITY },
          conditions: [],
          event: "",
          limit: {},
        },
      ],
      name: "add2ProductReviewsInLast60Days",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "refer5Friends",
          description: "refer5FriendsDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: CUSTOM_EVENT,
          type: REFERRAL,
          translations: { [defaultLang]: { name: "refer5Friends" } },
          achievementRuleId: "bafd5bad-1331-47a3-be78-749bb1c0282c",
          completeRule: {
            periodGoal: 5,
            period: { type: OVERALL },
          },
          aggregation: {
            type: EXPRESSION,
            rule: "",
          },
          conditions: [],
          event: "",
          limit: {},
        },
      ],
      name: "refer5Friends",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "track3RefereesTransactions",
          description: "track3RefereesTransactionsDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: TRANSACTION,
          type: REFERRAL,
          translations: {
            [defaultLang]: { name: "track3RefereesTransactions" },
          },
          achievementRuleId: "480fdf11-1e7a-4799-a5fe-40d408a74823",
          completeRule: {
            periodGoal: 3,
            period: { type: OVERALL },
          },
          aggregation: { type: QUANTITY },
          conditions: [],
          uniqueReferee: true,
          limit: {},
        },
      ],
      name: "track3RefereesTransactions",
    },
    {
      active: true,
      translations: {
        [defaultLang]: {
          name: "buyProductFromCategoryYAndX",
          description: "buyProductFromCategoryYAndXDescription",
        },
      },
      limit: { value: 1 },
      activity: {},
      rules: [
        {
          trigger: TRANSACTION,
          type: DIRECT,
          translations: { [defaultLang]: { name: "buyXAndY" } },
          achievementRuleId: "54b2bb14-f3f1-4b37-a158-55871d4a8dd1",
          completeRule: {
            periodGoal: 1,
            period: { type: OVERALL },
          },
          aggregation: { type: QUANTITY },
          conditions: [
            {
              operator: "is_greater_or_equal",
              attribute: "transaction.category('Y').qty",
              data: 1,
            },
            {
              operator: "is_greater_or_equal",
              attribute: "transaction.category('X').qty",
              data: 1,
            },
          ],
          limit: {},
        },
      ],
      name: "buyProductFromCategoryYAndX",
    },
  ];
  return data;
};
